<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem-tb" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__gold-tb" id="benefits_item__gold" @mouseover="onTrackHover">
      {{ $t('9 золота за каждые 100 RUB независимо от оборотов по карте') }}
    </p>
    <p class="benefits_item benefits_item__percent-bonus-tb" id="benefits_item__percent_bonus" @mouseover="onTrackHover">
      <span>{{ $t('5% от стоимости покупок в Премиум магазине в виде золота') }}</span>
    </p>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'

@Component
class BenefitsTbRu extends BenefitsBase {
}

export default BenefitsTbRu
</script>
